import { render, staticRenderFns } from "./vendor-finance-list.vue?vue&type=template&id=81a8e8d4&"
import script from "./vendor-finance-list.vue?vue&type=script&lang=js&"
export * from "./vendor-finance-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports